 
import React from 'react';
import {Link} from 'react-router';
import './../styles/actions.scss';

const Buttons = ({next, back, disableButton}) => {
    return (
        <nav className="nav-direction button-row button-container">
            {back && (
                <Link to={back} className="secondary button" data-icon="left">
                    Back
                    <span className="icon previous-page"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z"></path></svg></span>
                </Link>
            )}

            {next && (
                <Link
                    to={next}
                    aria-disabled={disableButton}
                    className={`${disableButton ? 'disable-next' : 'primary'} button`}
                    data-icon="right"
                >
                    {next === '/bridle-builder/review' ? 'Done' : 'Next'}
                    <span className="icon next-page"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z"></path></svg></span>
                </Link>
            )}
        </nav>
    );
};

export default Buttons;
